import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  RadioGroup, FormControlLabel, Radio, Button,
} from '@mui/material';
import PropTypes from 'prop-types';

const OPTIONS = [
  { value: 'ohlcv',        label: 'OHLCV',                          suffix: '' },
  { value: 'aspects_geo',  label: 'Planetary Aspects within Orb',   suffix: '(Geocentric)' },
  { value: 'aspects_helio',label: 'Planetary Aspects within Orb',   suffix: '(Heliocentric)' },
  { value: 'planets_sid',  label: "Planets' longitude, declination, distance and speed", suffix: '(Sidereal)' },
  { value: 'planets_trop', label: "Planets' longitude, declination, distance and speed", suffix: '(Tropical)' },
];

const BarFloaterSelectionDialog = ({ open, onClose, currentMode, onApply }) => {
  const [selected, setSelected] = useState(currentMode || 'ohlcv');

  // Sync with external prop when dialog opens
  React.useEffect(() => {
    if (open) setSelected(currentMode || 'ohlcv');
  }, [open, currentMode]);

  const handleOk = () => {
    onApply(selected);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: 2, px: 1 } }}>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 500, fontSize: '1.2rem' }}>
        Bar Floater Selection
      </DialogTitle>
      <DialogContent sx={{ pt: 1, pb: 2 }}>
        <RadioGroup value={selected} onChange={e => setSelected(e.target.value)}>
          {OPTIONS.map(opt => (
            <FormControlLabel
              key={opt.value}
              value={opt.value}
              control={<Radio />}
              label={
                <span>
                  {opt.label}
                  {opt.suffix && <span style={{ fontWeight: 600, marginLeft: 16 }}>{opt.suffix}</span>}
                </span>
              }
              sx={{ mb: 0.5 }}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose}>Cancel</Button>
        <Button variant="outlined" onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

BarFloaterSelectionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  currentMode: PropTypes.string,
  onApply: PropTypes.func.isRequired,
};

export default BarFloaterSelectionDialog;
